export enum MessageType {
  WebReady = "web_ready",
  Ping = "ping",
  Navigate = "navigate",
  Logout = "logout",
  CanGoBack = "can_go_back",
  OpenUrl = "open_url",
  DeleteAccount = "delete_account",
  ToggleDrawer = "toggle_drawer",
  SignInWithToken = "sign_in_with_token",
  RequestSignInToken = "request_signm_in_token",
}

type WebReady = {
  type: MessageType.WebReady;
};

type PingWebViewMessage = {
  type: MessageType.Ping;
  payload: string;
};

type SignInWithTokenWebViewMessage = {
  type: MessageType.SignInWithToken;
  token: string;
};

type RequestSignInTokenWebViewMessage = {
  type: MessageType.RequestSignInToken;
};

type ToggleDrawer = {
  type: MessageType.ToggleDrawer;
};

type LogoutWebViewMessage = {
  type: MessageType.Logout;
};

type NavigateWebViewMessage = {
  type: MessageType.Navigate;
  planUid?: string;
  moduleUid?: string;

  businessPlanUid?: string;
  feedItemUid?: string;
};

type CanGoBackWebViewMessage = {
  type: MessageType.CanGoBack;
  canGoBack: boolean;
};

type OpenUrlWebViewMessage = {
  type: MessageType.OpenUrl;
  url: string;
};

type DeleteAccountMessage = {
  type: MessageType.DeleteAccount;
};

export type WebViewMessage =
  | RequestSignInTokenWebViewMessage
  | SignInWithTokenWebViewMessage
  | WebReady
  | ToggleDrawer
  | DeleteAccountMessage
  | PingWebViewMessage
  | LogoutWebViewMessage
  | NavigateWebViewMessage
  | OpenUrlWebViewMessage
  | CanGoBackWebViewMessage;
